export default "__VITE_ASSET__snXmAEiL__"